var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('iframe',{attrs:{"width":"900","height":"800","src":"https://docs.google.com/presentation/d/1E1hXYnT5RFPsehEnaNnZSNIixMIg3RVmQAyk0CnNqAM/preview?usp=drive_web","frameborder":"1"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }